import style from './ModalSelectDevices.module.css';

import addIcon from 'assets/svg/add-01.svg';
import iconDelete from 'assets/svg/delete-01.svg';

import { observer } from 'mobx-react-lite';
import Modal from 'ui/Modal';
import { useEffect, useState } from 'react';
import RegularButton from 'ui/RegularButton';
import Select from 'ui/Select';
import { address_server_short } from 'config';
import Tooltip from 'ui/Tooltip';
import IconButton from 'ui/IconButton';
import { getListDevices } from 'services/list.services';
import Icon from 'ui/Icon';
import { deleteDeviceFromStorage, setDeviceToStorage } from 'services/storage.services';
import useAlert from 'hooks/useAlert';
import { PUBLIC_ASSETS } from 'config';
import { treeStore } from 'store/mobx/tree.store';

const ModalSelectDevices = observer(({ open, onClose, data }) => {
  const { showAlert } = useAlert();

  const { fetchNode } = treeStore;

  const [devices, setDevices] = useState(data.devices);
  const [source, setSource] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState(null);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    const result = await getListDevices();
    if (!result) return;

    setSource(result.data);
  };

  const handleDeleteDevice = async (id) => {
    const res = await deleteDeviceFromStorage(data.id, id);

    if (res.success) {
      await fetchNode(data.id, data?.entity);
      setDevices((prevValue) => prevValue.filter((i) => i.id !== id));
    }
  };

  const handleAddDevice = async () => {
    if (selectedDevice) {
      const result = await setDeviceToStorage(data.id, selectedDevice?.id);
      if (!result.success) errorAddedDeviceAlert(result.error_code, result.error);
      else {
        await fetchNode(data.id, data?.entity);
        setDevices((prevValue) => [...prevValue, selectedDevice]);
      }
      setSelectedDevice(null);
    }
  };

  const errorAddedDeviceAlert = (code, message) => {
    showAlert(` Код № ${code}${message ? ` - ${message}` : ''}!`, 'error');
  };

  const handleChangeSelect = (id) => {
    setSelectedDevice(source?.find((i) => i.id === id));
  };

  const Device = ({ device }) => (
    <>
      <div className={style.performerWrapper}>
        <div className={style.item}>
          <Icon
            width={30}
            height={30}
            src={address_server_short + PUBLIC_ASSETS + device.image}
            alt="оборудование"
          />
          <div
            style={{
              width: '85%',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <div className={style.ellipsis}>{device.name}</div>
            <div
              style={{
                display: 'flex',
                color: 'grey',
                fontSize: '13px',
              }}
            >
              (инв.
              <div
                className={style.ellipsis}
                style={{
                  marginLeft: '0.5rem',
                }}
              >
                {device?.inventory_number}
              </div>
              )
            </div>
          </div>
        </div>
        <Tooltip text="Удалить">
          <IconButton
            onClick={() => handleDeleteDevice(device.id)}
            icon={iconDelete}
            size="16"
            color="primary"
          />
        </Tooltip>
      </div>
      <div className={style.divider} />
    </>
  );

  return (
    <Modal
      title="Редактировать оборудование"
      hideDefaultFooter
      submitText="Сохранить"
      onClose={onClose}
      open={open}
    >
      <div className={style.selectionWrapper}>
        <Select
          options={source}
          value={selectedDevice?.id}
          onChange={handleChangeSelect}
          className={style.select}
          notSelectedText="Не выбрано"
          renderOption={({ option }) => (
            <div className={style.itemSelect}>
              <Icon
                width={30}
                height={30}
                src={address_server_short + PUBLIC_ASSETS + option.image}
                alt="оборудование"
              />
              <div
                style={{
                  width: '85%',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <div className={style.ellipsis}>{option.name}</div>
                <div
                  style={{
                    display: 'flex',
                    color: 'grey',
                    fontSize: '13px',
                  }}
                >
                  (инв.
                  <div
                    className={style.ellipsis}
                    style={{
                      marginLeft: '0.5rem',
                      width: 'auto',
                    }}
                  >
                    {option?.inventory_number}
                  </div>
                  )
                </div>
              </div>
            </div>
          )}
        />
        <RegularButton
          onClick={handleAddDevice}
          appendIcon={<Icon color={'#ffffff'} src={addIcon} width={'12px'} height={'12px'} />}
          className={style.button}
          color="primary"
          variant="flat"
          text="Добавить"
          disabled={!selectedDevice}
        />
      </div>
      <div className={style.container}>
        {(devices?.length &&
          devices?.map((device) => <Device key={device.id} device={device} />)) || (
          <div className={style.notPerformer}>Оборудование не добавлено</div>
        )}
      </div>
    </Modal>
  );
});

export default ModalSelectDevices;
